import VueRouter from "vue-router";

export default function (router: VueRouter): void {
  const histories = router.currentRoute.matched;
  if (histories.length && histories[0].path !== router.currentRoute.path) {
    router.push({ path: histories[0].path, replace: true });
  }
}
